import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { listStudies, getStudy, updateStudy } from "@/api/client";

interface StudyFilters {
  status?: string;
  phase?: string;
  edcSystem?: string;
  limit?: number;
  startAfter?: string;
}

export function useStudies(filters?: StudyFilters) {
  return useQuery({
    queryKey: ["studies", filters],
    queryFn: () => listStudies(filters ?? {}),
    staleTime: 2 * 60 * 1000,
  });
}

export function useStudy(studyId: string | undefined) {
  return useQuery({
    queryKey: ["study", studyId],
    queryFn: () => getStudy({ studyId: studyId! }),
    enabled: !!studyId,
    staleTime: 2 * 60 * 1000,
  });
}

export function useUpdateStudy() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateStudy,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["studies"] });
      queryClient.invalidateQueries({ queryKey: ["study"] });
    },
  });
}
